import { OrderSetupStatusEnum } from "Infrastructure/Api/Api";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useCreateOrderSetupMutation } from "Settings/Modules/OrderSetup/Api/Mutation/useCreateOrderSetupMutation";
import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import type { FC } from "react";

type Props = {
	verticalId: number;
	marketId: number;
};

const orderSetupResource = Resources.base.orderSetup.shared;

export const OrderSetupCreateButton: FC<Props> = ({ verticalId, marketId }) => {
	const { t } = useResource();
	const { mutate: createOrderSetup } = useCreateOrderSetupMutation();

	const handleCreateOrderSetup = () => {
		createOrderSetup({
			verticalId,
			marketId,
			status: OrderSetupStatusEnum.draft,
		});
	};

	return (
		<Button
			variant="contained"
			color="primary"
			sx={{ mb: 2 }}
			onClick={handleCreateOrderSetup}
			startIcon={<Add />}
			disabled={!hasPermission(UserPermissions.OrderSetupModule.create)}
		>
			{t(orderSetupResource.addSetup)}
		</Button>
	);
};
